import { defineMessages } from 'react-intl';

export default defineMessages({
  mergePullRequestAction: {
    id: 'frontbucket.repository.pullRequest.mergePullRequest',
    description: 'Action to merge a pull request',
    defaultMessage: 'Merge',
  },
  pendingMergeIconLabel: {
    id: 'frontbucket.repository.pullRequest.pendingMergeIconLabel',
    description:
      'Label passed in "clock" icon indicating that the merge is pending',
    defaultMessage: 'Pending merge',
  },
  pendingMergeInfo: {
    id: 'frontbucket.repository.pullRequest.pendingMergeInfo',
    description:
      'Message that appears when a user hovers above the pending merge button',
    defaultMessage:
      'This pull request will automatically merge once builds pass',
  },
  disabledMergeInfo: {
    id: 'frontbucket.repository.pullRequest.disableMergeInfo',
    description:
      'Message that appears when a user hovers above a disabled merge button',
    defaultMessage: 'Update the pull request before merging',
  },
  notReadyToMergeIconLabel: {
    id: 'frontbucket.repository.pullRequest.notReadyToMergeIconLabel',
    description:
      'Label passed in "warning" icon indicating that the pull request is not ready to merge',
    defaultMessage: 'Not ready to merge',
  },
});
